// eslint-disable-next-line import/extensions
import { ResourceType } from '../../graphQL/index.js';
import { BEACON_RESOURCE_METADATA, isBeaconResource } from './constants/beaconResourceMetadata';
import { CAMPUS_RESOURCE_METADATA } from './constants/campusResourceMetadata';

export const getResourceDisplayName = (resourceType: ResourceType): string => {
  if (isBeaconResource(resourceType)) {
    const metadata =
      BEACON_RESOURCE_METADATA[resourceType as keyof typeof BEACON_RESOURCE_METADATA];
    return metadata?.title || resourceType;
  }
  const metadata = CAMPUS_RESOURCE_METADATA[resourceType as keyof typeof CAMPUS_RESOURCE_METADATA];
  return metadata?.title || resourceType;
};
